import { render, staticRenderFns } from "./SelectRolesComponent.vue?vue&type=template&id=466ec323&scoped=true&"
import script from "./SelectRolesComponent.vue?vue&type=script&lang=js&"
export * from "./SelectRolesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466ec323",
  null
  
)

export default component.exports